import React from 'react';
import { get } from 'lodash-es';

import { Card, SelectFieldWithLabel, StatusMessage, NumberFieldWithLabel, TextArea, TextFieldWithLabel, ButtonGroup, Button } from '../components/library-components';

import { getSubscriptionGroups, postPreviewSubscription, postCreateSubscription } from '../api';

class AddOrganizationSubscription extends React.Component {
  constructor () {
    super();
    this.state = {
      subscriptionGroups: [],
      selectedSubscriptionGroup: null,
      selectedSubscriptionPlan: null,
      showNotification: false
    };
  }

  componentDidMount () {
    getSubscriptionGroups('group_access')
      .then(subscriptionGroups => this.setState({ subscriptionGroups }));
  }

  makeSelectOptions (arrayOptions) {
    return arrayOptions.map(option => ({ label: option.name || option.title, value: option }));
  }

  getSubscriptionPlans () {
    const plans = get(this.state, ['selectedSubscriptionGroup', 'value', 'subscription_plans'], [])
      .filter(plan => !plan.recurring);
    return this.makeSelectOptions(plans);
  }

  createSubscription () {
    const payment = {
      payment_type: 'manual',
      amount_cents: this.state.amountCents,
      amount_currency: this.state.amountCurrency
    };
    const subscription = {
      notes: this.state.notes || '',
      subscription_plan_id: this.state.selectedSubscriptionPlan.value.id,
      payment: payment
    };

    postPreviewSubscription('email', this.props.orgPrimaryEmail, { subscription })
      .then(response => postCreateSubscription('email', this.props.orgPrimaryEmail, this.state.selectedSubscriptionPlan.value.id, payment, subscription, response['attempt_token']))
      .then(() => {
        this.props.getOrganizationSubscriptions();
        this.setState({ selectedSubscriptionGroup: null, selectedSubscriptionPlan: null });
      });
  }

  render () {
    if (!this.props.allowAddingSubscription) {
      return (
        <>
          <Card>
            <div
              onClick={() => this.setState({ showNotification: true })}
              style={{ cursor: 'pointer' }}
              data-test-id='add-subscription-btn'
            >
              <b>Add New subscription</b>
            </div>
          </Card>
          {this.state.showNotification && (
            <StatusMessage
              statusMessage='Please save the data before creating new subscription.'
              status='error'
              onCancel={() => { this.setState({ showNotification: false }); }}
            />
          )}
        </>
      );
    }

    return (
      <Card title='Add New subscription'>
        <div className='form-row'>
          <SelectFieldWithLabel
            label='Subscription group'
            value={this.state.selectedSubscriptionGroup}
            options={this.makeSelectOptions(this.state.subscriptionGroups)}
            onChange={e => this.setState({ selectedSubscriptionGroup: e })}
            clearable={false}
          />
          <SelectFieldWithLabel
            label='Subscription plan'
            value={this.state.selectedSubscriptionPlan}
            options={this.getSubscriptionPlans()}
            onChange={e => this.setState({ selectedSubscriptionPlan: e, amountCents: e.value.price_cents, amountCurrency: e.value.price_currency, userLimit: e.value.user_limit })}
            clearable={false}
            disabled={this.state.selectedSubscriptionGroup === null}
          />
        </div>
        {this.state.selectedSubscriptionPlan && (
          <>
            <div className='form-row'>
              <div className='text-and-select'>
                <NumberFieldWithLabel
                  label='Amount Paid'
                  onChange={(e) => this.setState({ amountCents: e.target.value * 100 })}
                  placeholder='Amount Paid'
                  dataTest='amount-paid'
                  value={this.state.amountCents / 100}
                />

                <SelectFieldWithLabel
                  className='select-currency'
                  value={this.state.amountCurrency}
                  options={[{ label: this.state.amountCurrency, value: this.state.amountCurrency }]}
                  clearable={false}
                />
              </div>
              <TextFieldWithLabel
                label='User limit'
                value={this.state.userLimit}
                dataTest='user_limit'
                disabled
              />
            </div>
            <TextArea
              label='Notes'
              value={this.state.notes}
              placeholder="Enter subscription's notes"
              onChange={(e) => this.setState({ notes: e.target.value })}
              dataTest='notes'
            />
            <ButtonGroup>
              <Button
                primary
                onClick={() => this.createSubscription()}
                dataTest='save_subscription'
              >
                Save
              </Button>
            </ButtonGroup>
          </>
        )}
      </Card>
    );
  }
}

export default AddOrganizationSubscription;
